import { default as angular } from "angular";
import uiRouter from "@uirouter/angularjs/lib-esm";
import { moduleName as recordsModuleName } from "../records";
import {
  vsName as processDetailComponentName,
  processDetailComponentOptions,
} from "./views/ProcessDetail";
import {
  vsServiceName as WorkItemTypeServiceName,
  WorkItemTypeServiceProvider,
} from "./workItemTypes/provider";
import { WorkItemTypeServiceProviderConfig } from "./workItemTypes/config";
import {
  processViewComponentOptions,
  vsComponentName as processViewComponentName,
} from "./views/ProcessGroupGrid/component";

import {
  vsServiceName as ProcessInformationServiceName,
  ProcessInformationServiceProvider,
} from "./services/processInformationService";

import { vsModuleName as signatureModuleName } from "../ui/signature/module";
import {
  workItemWrapperDirective,
  vsDirectiveName as workItemWrapperDirectiveName,
} from "./views/ProcessDetail/workItemWrapper/directive";

import {
  workflowItemRecursiveDirective,
  vsDirectiveName as workflowItemRecursiveDirectiveName,
} from "./views/ProcessDetail/workflowItemRecursive/directive";

import { vsModuleName as objectsModule } from "./config/objects";
import {
  processGridComponentOptions,
  vsComponentName as processGridComponentName,
} from "./views/ProcessInstancesGrid";
import { routeConfig } from "./routes";

export const vsName = "SlotTrak.Process";
angular
  .module(vsName, [
    uiRouter,
    recordsModuleName,
    signatureModuleName,
    "ui.bootstrap",
    objectsModule,
  ])
  .config(routeConfig)
  .component(processDetailComponentName, processDetailComponentOptions)
  .component(processViewComponentName, processViewComponentOptions)
  .component(processGridComponentName, processGridComponentOptions)
  .provider(WorkItemTypeServiceName, WorkItemTypeServiceProvider)
  .directive(workItemWrapperDirectiveName, workItemWrapperDirective)
  .directive(workflowItemRecursiveDirectiveName, workflowItemRecursiveDirective)
  .config(WorkItemTypeServiceProviderConfig)
  .provider(ProcessInformationServiceName, ProcessInformationServiceProvider);
export default vsName;
